'use strict';

import template from './reports.status.time.directive.html';

export default angular
  .module('main.reports.status.time', [])
  .directive('reportsStatusTime', () => {
      return {
        restrict: 'E',
        template: template,
        scope: {
          sections: '=sections',
          loading: '=loading',
          searchVal: '=search',
          isError: '=error',
        },
      };
    }
  )

  .name;
